import { appstr } from "@coreapp/utils/appstr";

export const createMinimumDelay = (minimumDelay: number) => {
  const initialTime = Date.now();

  return async () => {
    const timeoutTimer = minimumDelay - (Date.now() - initialTime);
    await new Promise(resolve => setTimeout(resolve, timeoutTimer));
  };
};

export function getLocalizedPaginationStrings() {
  return {
    showingResults: appstr("Showing results"),
    next: appstr("Next (short)"),
    prev: appstr("Prev (short)"),
    resultsPerPage: appstr("Results per page")
  };
}

export function getLocalizedColorPickerStrings() {
  return {
    solidColor: appstr("solidline"),
    gradientColor: appstr("Gradient"),
    linearGradient: appstr("Linear Gradient"),
    radialGradient: appstr("Radial Gradient"),
    nofill: appstr("nofill"),
    customColors: appstr("Custom")
  };
}

export function getLocalizedTableHeaderStrings() {
  return {
    placeholder: appstr("Search"),
    selectAllLabel: appstr("Select All")
  };
}

export const matchesRoute = (route: string, matchingRoutes: string[]) => {
  return matchingRoutes.some(path => {
    // '/' === '/'
    if (path.length === 1) {
      return route === path;
    }

    return route.startsWith(path);
  });
};
